
const drivetrainEnum = {
  AllWheelDrive: ['All Wheel Drive', 'AWD'],
  FourWheelDrive: ['Four Wheel Drive', '4WD'],
  RearWheelDrive: ['Rear Wheel Drive', 'RWD'],
  FrontWheelDrive: ['Front Wheel Drive', 'FWD']
}
/**
 * Converts graphql drivetrain enumeration values to display values.
 * @param {String} value
 * @return {String}
 */
export default (value, { abbreviate = false } = {}) => (drivetrainEnum[value]?.[Number(abbreviate)] || '')
